import { usePtContext } from '@/contexts/PtContext';

const useUserLoggedIn = () => {
  const { cognitoUser } = usePtContext();
  return !!cognitoUser;
};

export default useUserLoggedIn;
